/**
 * List of menu items for Top Menu
 */
export const TopMenuLinks = [
  // {
  //   path: "/landing#about-acsw",
  //   className: "link",
  //   exact: true,
  //   title: "header.topMenu._about_acsw"
  // },
  // {
  //   path: "/landing#redemption-items",
  //   className: "link",
  //   exact: true,
  //   title: "header.topMenu._redemption_items"
  // },
  // {
  //   path: "/landing#t&cs",
  //   className: "link",
  //   exact: true,
  //   title: "header.topMenu._t&cs"
  // }
  // {
  // 	path: "/sign-in",
  // 	className: "btn btn-small btn-primary",
  // 	exact: true,
  // 	title: "header.topMenu._login_signup",
  // },
];

/**
 * List of menu items for Sidebar Menu
 */
export const SidebarMenuLinks = [
  {
    path: "/dashboard",
    className: "link",
    exact: true,
    title: "sidebar.navigation._dashboard",
    icon: "images/icons/icon-dashboard.png"
  },
  {
    path: "/rewards",
    exact: true,
    className: "link",
    title: "sidebar.navigation._rewards",
    icon: "images/icons/icon-star.png"
  },
  {
    path: "/transactions",
    className: "link",
    title: "sidebar.navigation._transactions",
    icon: "images/icons/icon-mytransaction.png"
  },
  {
    path: "/rewards-catalogue",
    className: "link",
    title: "sidebar.navigation._rewardsCatalogue",
    icon: "images/icons/icon-reward.png"
  },
  {
    path: "/invite-friends",
    className: "link",
    exact: true,
    title: "sidebar.navigation._inviteFriends",
    icon: "images/icons/icon-invite.png"
  },
  {
    path: "/profile",
    className: "link",
    exact: true,
    title: "sidebar.navigation._updateProfile",
    icon: "images/icons/icon-face.png"
  },
  {
    path: "/profile/change-password",
    className: "link",
    exact: true,
    title: "sidebar.navigation._changePassword",
    icon: "images/icons/icon-pw.png"
  },
  // {
  //   path: "/cards",
  //   className: "link",
  //   title: "sidebar.navigation._cards"
  // },
  {
    path: "#",
    isBlank: true,
    pathBlank: "https://mrcoconut.sg/faq/",
    className: "link",
    exact: true,
    title: "FAQ",
    icon: "images/icons/icon-faq.png"
  },
  {
    path: "#",
    isBlank: true,
    pathBlank: "https://mrcoconut.sg/enquiries/",
    className: "link",
    exact: true,
    title: "Contact Us",
    icon: "images/icons/icon-contact-us.png"
  }
  // {
  // 	path: "/contact-us",
  // 	className: "link",
  // 	title: "sidebar.navigation._contactUs",
  // },
  // {
  // 	path: "/logout",
  // 	className: "link",
  // 	title: "sidebar.navigation._logout",
  // },
  /*{
		path: "/unregister",
		className: "link link-primary fw-bolder",
		title: "sidebar.navigation._unregister",
	},*/
];

/**
 * List of menu items for Footer menu
 */
export const FooterMenuLinks = [
  {
    title: "About Us",
    titlePath: "#",
    items: [
      {
        path: "#",
        className: "link",
        exact: true,
        title: "CSR & Sustainability"
      },
      {
        path: "#",
        className: "link",
        exact: true,
        title: "Corporate Profile"
      },
      {
        path: "#",
        className: "link",
        exact: true,
        title: "Leadership Team"
      },
      {
        path: "#",
        className: "link",
        exact: true,
        title: "Purpose, Vision and Values"
      },
      {
        path: "#",
        className: "link",
        exact: true,
        title: "Our History"
      },
      {
        path: "#",
        className: "link",
        exact: true,
        title: "Our Global Presence"
      }
    ]
  },
  {
    title: "Media Center",
    titlePath: "#",
    items: [
      {
        path: "#",
        className: "link",
        exact: true,
        title: "News"
      },
      {
        path: "#",
        className: "link",
        exact: true,
        title: "Events & Promotions"
      }
    ]
  },
  {
    title: "Career",
    titlePath: "",
    items: [
      {
        path: "#",
        className: "link",
        exact: true,
        title: "Overview"
      }
    ]
  }
];

export const viFooterMenuLinks = [];



// WEBPACK FOOTER //
// ./src/configs/MenuLinks.js